import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { maybeUserSelector } from 'features/user/redux/selectors';

const PrivateRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  const user = useSelector(maybeUserSelector);

  return (
    <Route
      {...rest}
      render={(props) =>
        user != null && Component ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
            }}
          />
        )
      }
    />
  );
};

export { PrivateRoute };
